// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","PanelFooter":"bcl_a bhb_b bhb_tu bhb_qz bhb_ra bhb_uo","PanelFooter--link":"bcl_b"};